module.exports = __webpack_public_path__ + "static/media/tick.f93252f0.svg";